import { SecurityOverviewBadgeEnum } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { IconName, Tag } from '@optimus-web/core';
import { TooltippedSpan } from '@mews-commander/ui';
import { securityOverviewContent } from './contentMapping';

export const SecurityBadge = ({ level }: { level: SecurityOverviewBadgeEnum }) => {
    const badgeContent = securityOverviewContent[level];

    return (
        <TooltippedSpan tooltip={lt(badgeContent.tooltipTextKey)}>
            <Tag variant={badgeContent.variant} leadingIcon={IconName.Security}>
                {lt(badgeContent.textKey)}
            </Tag>
        </TooltippedSpan>
    );
};
